import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * Componente estilizado para IconButton con variantes predefinidas
 */
const StyledIconButton = styled(IconButton)(({ theme, variant, disabled }) => {
  const baseStyles = {
    size: 'small',
    transition: 'all 0.2s ease-in-out',
    '&:disabled': {
      opacity: 0.5,
      transform: 'none',
      cursor: 'not-allowed',
    },
  };

  const variantStyles = {
    edit: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: 'rgba(94, 137, 79, 0.08)',
        transform: 'scale(1.1)',
      },
    },
    delete: {
      color: theme.palette.error.main,
      '&:hover': {
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
        transform: 'scale(1.1)',
      },
    },
  };

  return {
    ...baseStyles,
    ...variantStyles[variant],
    ...(disabled && {
      '&:hover': {
        backgroundColor: 'transparent',
        transform: 'none',
      },
    }),
  };
});

/**
 * Componente ActionIconButton - Botón de acción con icono
 *
 * @param {string} variant - Variante del botón ('edit' o 'delete')
 * @param {function} onClick - Función callback para el evento click
 * @param {boolean} disabled - Estado deshabilitado del botón
 * @param {object} sx - Estilos adicionales
 * @param {object} iconProps - Props adicionales para el icono
 * @param {object} props - Props adicionales para el IconButton
 */
const ActionIconButton = ({
  variant = 'edit',
  onClick,
  disabled = false,
  sx = {},
  iconProps = {},
  ...props
}) => {
  // Mapeo de iconos según la variante
  const IconComponent = {
    edit: EditIcon,
    delete: DeleteIcon,
  }[variant];

  // Props por defecto para el icono
  const defaultIconProps = {
    fontSize: 'small',
    ...iconProps,
  };

  return (
    <StyledIconButton
      size="small"
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      sx={sx}
      {...props}
    >
      <IconComponent {...defaultIconProps} />
    </StyledIconButton>
  );
};

export default ActionIconButton;
